//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

/**
 * Formats a search term for the Product Catalog API's query syntax.
 *
 * The Product Catalog API uses a specific query syntax for complex searches:
 * - Format: `field:value*`
 * - The asterisk (*) enables prefix matching
 * - Multiple fields can be combined with operators
 *
 * @see https://catalog-bazaar.prod.us-east-1.nexus.bazaarvoice.com/swagger#/
 *
 * @param searchTerm - The user's search input
 * @param field - The field to search (e.g., 'name', 'externalID')
 * @returns Formatted search query string, or empty string if no search term
 *
 * @example
 * formatProductCatalogSearch('Nike', 'name') // Returns: "name:Nike*"
 * formatProductCatalogSearch('', 'name') // Returns: ""
 */
export const formatProductCatalogSearch = (
  searchTerm: string,
  field: string,
): string => {
  const trimmed = searchTerm.trim();
  return trimmed ? `${field}:${trimmed}*` : '';
};
